var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Page',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('PageTitle',[_vm._v(" Course Dashboard ")])]},proxy:true}])},[_c('v-row',[_c('v-col',[_c('InstructorCourseDashboard')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }